function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { t } from '../i18n';
import SvgIcon from './SvgIcon';
import classNames from 'classnames';
var defaultProps = {
  className: '',
  viewBox: '0 0 20 20'
};

function MinusCircleIcon(props) {
  var iconCssClasses = classNames('ds-c-icon--minus-circle', props.className);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: t('icons.remove')
  }, defaultProps, props, {
    className: iconCssClasses
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.000000, -360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.000000, 362.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ds-c-icon--minus-circle__circle",
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "#FFFFFF",
    cx: "8",
    cy: "8",
    r: "9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ds-c-icon--minus-circle__group",
    transform: "translate(2.823529, 7.223529)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.17647059,-4.4 C5.60530345,-4.4 5.95294118,-4.05236228 5.95294118,-3.62352941 L5.95294118,5.17647059 C5.95294118,5.60530345 5.60530345,5.95294118 5.17647059,5.95294118 C4.74763772,5.95294118 4.4,5.60530345 4.4,5.17647059 L4.4,0.132872909 L4.4,-3.62352941 C4.4,-4.05236228 4.74763772,-4.4 5.17647059,-4.4 Z",
    transform: "translate(5.176471, 0.776471) rotate(-270.000000) translate(-5.176471, -0.776471) "
  }))))));
}

export default MinusCircleIcon;